import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { start_loader, stop_loader, setStep, registerNewUser, afterSignupOtherUsers, setPageTitle, onboardingUserTrack, setConditionIndex } from "../../actions";
import * as constand from "../../constant";
import { toast } from "react-toastify";
import { commonService } from "../../_services";

class ResearchNiceoneComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: {},
            is_postnatal: false,
            submitted: false,
            disableButton: false,
            currentCondition: 0,
            isRSCodeSingup: true
        };
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.finalSubmit = this.finalSubmit.bind(this);
        this.modalContent = {};
        this.selected_condition_list = this.props.registerFormvalues.health_condition[
            this.props.condition_index
        ];
        console.log("Myprops", this.props)
    }
    componentDidMount() {
        this.props.start_loader();
        if (Object.keys(this.props.registerFormvalues.tagCode).length)
            this.modalContent = JSON.parse(this.props.registerFormvalues.tagCode.modalContent);
    }
    handleCheckboxChange(e) //for twoway binding checkbox
    {
        const { name } = e.target;
        this.props.registerFormvalues[name] = !this.props.registerFormvalues[name];
        this.props.registerFormvalues.tagCodeList['cond_' + this.selected_condition_list.id][name] = !this.props.registerFormvalues[name];
    }
    finalSubmit = (event) => {
        event.stopPropagation()
        this.setState({ submitted: true, promoCodeErr: false, subscribedErr: false });
        this.props.registerformUpdate(this.props.registerFormvalues);
        //if (this.props.registerFormvalues.isKBResearcheUser) { for testing
        if (!this.props.registerFormvalues.research) {  //all core conditions
            if (this.modalContent.consentSwitch && this.modalContent.consentSwitch === constand.SHARE_MANDATORY && !this.props.registerFormvalues.research_share)
                return;
            else {
                this.setState({ submitted: false });
                this.props.registerFormvalues.tagCodeList['cond_' + this.selected_condition_list.id]['research_share'] = true;
                this.props.registerformUpdate(this.props.registerFormvalues);
                console.log('***NICEONE=this.props.registerFormvalues', this.props.registerFormvalues)
                //this.props.gotoStep(16); //kidney nice one page
                //this.props.gotoStep(23); //membership options --old
                if (this.props.condition_index <
                    this.props.registerFormvalues.health_condition.length - 1) {
                    this.props.setConditionIndex(this.props.condition_index + 1)
                    this.props.pageFrom == 'register' ? this.onboardingUserTrack(11) : this.props.gotoStep(11) //profession
                } else {
                    console.log('ELSESSSSSSSSSSSSs')
                    if (this.props.pageFrom == "register") {
                        this.onboardingUserTrack(14, 'forward') //hear aboutus
                    } else {
                        this.props.setStep(23) // membership options
                    }
                }
            }
        } else {
            this.registerUser(this.props.registerFormvalues);
        }
    }

    onboardingUserTrack = (step, flow = false) => {
        let registerData = {
            registerEmail: this.props.registerFormvalues.email,
            formValues: this.props.registerFormvalues
        }
        this.props.onboardingUserTrack(registerData).then((res) => {
            let direction = flow ? flow : '';
            this.props.setStep(step, direction)
        })
    }

    /**
     register new user
    **/
     registerUser(registerFormvalues) {
        this.setState({ submitted: true });
        if (!registerFormvalues.research_share)
            return;
        this.props.start_loader();
        this.props.registerNewUser(registerFormvalues).then(
            response => {
                this.setState({ submitted: false });
                if (response && response.success) {
                    var user = response;
                    user.authdata = window.btoa(registerFormvalues.email + ':' + registerFormvalues.password);
                    sessionStorage.setItem('user', JSON.stringify(user));
                    this.props.afterSignupOtherUsers();
                    const { from } = { from: { pathname: "/group/liveclasses/list/" + registerFormvalues.research_groupname + "/" + commonService.replaceChar(registerFormvalues.research_condition, false) } };
                    this.props.history.push(from);
                }
            },
            error => {
                this.props.stop_loader();
                this.setState({
                    Loading: false
                });
                toast.error(error);
            }
        );
    }

    renderRS = () => {
        var condition = this.props.condition.replace(' ', '-');
        var welcomeTitle = this.props.registerFormvalues.research_condition;
        var trialName = this.props.registerFormvalues.research_condition.replace('Research Studies: ', '');
        var isResearchCondition = this.props.registerFormvalues.research_condition.includes('Research');
        var isCreatec = (trialName.toLowerCase().includes(constand.CREATEC_CONDITION))

        if (this.props.registerFormvalues.isKBResearcheUser) {
            trialName = constand.KD_STUDY_NAME;
            welcomeTitle = constand.KD_STUDY_NAME;
        }
        if (welcomeTitle.includes('iREHAB')) {
            welcomeTitle = welcomeTitle.slice(0, -6)
            trialName = " "
        }

        return (

            <div className="step16">
                <h3 className="text-center">
                    <a
                        className="pull-left"
                        href="javascript:void(0)"
                        onClick={() => this.props.setStep(4, 'backward')}
                    >
                        <img className="arrow-img" src={constand.WEB_IMAGES + "arrow-left.png"} />
                    </a>
                    Welcome to Kidney Beam {welcomeTitle}
                    <Link
                        to="/"
                        className="close-register orangefont"
                    >X</Link>
                </h3>
                <div className="row justify-content-center align-items-center">
                    <div className="input_section col-md-10 m-t-10">
                        <div class="row">
                            <div className="video-tag1 col-md-12 font-14 font-qregular black-txt">
                                <p className="font-bold">{isCreatec ? trialName + " feasibility study " : trialName + " Research Trial"}</p>
                                {isCreatec &&
                                    <p>
                                        You are signed up to take part in the {trialName} feasibility study on Kidney Beam. To proceed we need you to confirm you are happy for us to share your name, email and activity data that we collect on you on Kidney Beam with the researchers at the {constand.createc_org} who holds the educational class you take on Kidney Beam.</p>
                                    ||

                                    <p>
                                        Looks like you are signed up to take part in the {trialName} research trial on Kidney Beam. To proceed we need you to confirm you are happy for us to share your name, email and activity data that we collect on you on Kidney Beam with {(isResearchCondition ? (this.props.registerFormvalues.research_condition.indexOf('PULSE') != -1 ? constand.pulse_org : this.props.registerFormvalues.research_condition.indexOf('iREHAB') != -1 ? ' ' :  this.props.registerFormvalues.research_condition.indexOf('YOGA') != -1 ? constand.YOGA_ORG_NAME:constand.other_org) : constand.KD_ORG_NAME)} and any instructors of the classes you take on Kidney Beam.</p>
                                }

                            </div>
                        </div>
                        <div className="toggle-btns float-left w-100">
                            <span className="font-14 font-qregular black-txt">I consent to Kidney Beam sharing my data as described above</span>
                            <label className="switch m-l-10 pull-right" htmlFor="research_share">
                                <input type="checkbox" name="research_share" id="research_share" defaultChecked={this.props.registerFormvalues.research_share} onChange={this.handleCheckboxChange} value={this.props.registerFormvalues.research_share} />
                                <div className="slider round"></div>
                            </label>
                        </div>
                        {this.state.submitted && !this.props.registerFormvalues.research_share &&
                            <p className="text-danger">This is required.</p>}
                        <div
                            id="register-link"
                            className=" w-100 m-b-30 float-left p-t-15"
                        >
                            <button
                                className="w-50 mx-auto d-table btn  dblog_btn font-14 button-lightblue position-relative"
                                disabled={this.state.disableButton}
                                onClick={(e) => this.finalSubmit(e)}
                            >
                                Sign me up!
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        );
    }

    renderTagCodes = () => {
        var condition = this.props.condition.replace(' ', '-');
        var welcomeTitle = '';
        var trialName = this.props.registerFormvalues.research_condition.replace('Research Studies: ', '');
        var isResearchCondition = this.props.registerFormvalues.research_condition.includes('Research');
        var isCreatec = (trialName.toLowerCase().includes(constand.CREATEC_CONDITION))
        
        var modalContent = JSON.parse(this.props.registerFormvalues.tagCode.modalContent);
        if (this.props.registerFormvalues.tagCode) {
            trialName = modalContent.subtitle; //constand.KD_STUDY_NAME;
            welcomeTitle = modalContent.title;
        }

        this.props.setPageTitle(modalContent.title);
        return (

            <div className="step16">
                {this.props.pageFrom != 'mycondition' &&
                    <h3 className="text-center">
                        <a
                            className="pull-left"
                            href="javascript:void(0)"
                            onClick={() => this.props.setStep(4, 'backward')}
                        >
                            <img className="arrow-img" src={constand.WEB_IMAGES + "arrow-left.png"} />
                        </a>
                        {modalContent.title}
                        <Link
                            to="/"
                            className="close-register orangefont"
                        >X</Link>
                    </h3>
                }
                <div className="row justify-content-center align-items-center">
                    <div className="input_section col-md-10 m-t-10">
                        <div class="row">
                            <div className="video-tag1 col-md-12 font-14 font-qregular black-txt">
                                <p className="font-bold">{modalContent.subtitle}</p>
                                <p>{modalContent.paragraph}
                                </p>
                            </div>
                        </div>
                        {modalContent.consentStatement && modalContent.consentSwitch &&
                            <div className="toggle-btns float-left w-100">
                                <span className="font-14 font-qregular black-txt">{modalContent.consentStatement}</span>
                                <label className="switch m-l-10 pull-right" htmlFor="research_share">
                                    <input type="checkbox" name="research_share" id="research_share" defaultChecked={this.props.registerFormvalues.research_share} onChange={this.handleCheckboxChange} value={this.props.registerFormvalues.research_share} />
                                    <div className="slider round"></div>
                                </label>
                            </div>
                        }
                        {modalContent.consentSwitch && modalContent.consentSwitch === constand.SHARE_MANDATORY && this.state.submitted && !this.props.registerFormvalues.research_share &&
                            <p className="text-danger">This is required.</p>}
                        <div
                            id="register-link"
                            className=" w-100 m-b-30 float-left p-t-15"
                        >
                            <button
                                className="w-50 mx-auto d-table btn  dblog_btn font-14 button-lightblue position-relative"
                                disabled={this.state.disableButton}
                                onClick={(e) => this.finalSubmit(e)}
                            >
                                {this.props.registerFormvalues.research_condition.includes('Research') ? 'Sign me up!' : 'Next'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        );
    }

    render() {
        var isResearchCondition = this.props.registerFormvalues.research_condition.includes('Research');
        var tagCode = Object.keys(this.props.registerFormvalues.tagCode).length ? true : false;
        return (
            <div className="step16">
                {isResearchCondition && this.renderRS()}
                {!isResearchCondition && tagCode && this.renderTagCodes()}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        logged_userData: state.header.logged_userData,
        healthcondition_list: state.register.healthcondition_list,
        condition: state.auth.condition,
        condition_index: state.register.condition_index

    };
};

const mapDispatchToProps = { start_loader, stop_loader, setStep, registerNewUser, afterSignupOtherUsers, setPageTitle, onboardingUserTrack, setConditionIndex };

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResearchNiceoneComponent);
